import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import MuiSelect from '@material-ui/core/Select';
import { opacity } from '../theme/colors';

const styles = theme => ( {
    icon: {
        marginRight: 8,
        paddingLeft: 8,
    },
    root: {
        height: 36
    },
    select: {
        backgroundColor: opacity.black04,
        borderRadius: '2px 2px 0 0',
        boxSizing: 'border-box',
        height: '100%',
        paddingLeft: 16,
        width: '100%',
    },
} );

class Select extends Component{
    render(){
        const { classes, children } = this.props;
        return (
            <MuiSelect
                MenuProps={{
                    anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
                    getContentAnchorEl: null
                }}
                classes={{
                    icon: classes.icon,
                    root: classes.root,
                    select: classes.select,
                }}
                {...this.props}
            >
                {children}
            </MuiSelect>
        );
    }
}

Select.propTypes = {
    children: PropTypes.array,
    classes: PropTypes.object.isRequired,
};

export default withStyles( styles )( Select );
